<template>
    <ion-radio-group aira-label="recipe-name" mode="md" :value="localModelValue">
        <ion-item
            :aria-label="labelDisplay(option)"
            v-for="option in sorted"
            :key="option[keyName]"
            button
            lines="none"
            :class="{ dense: dense, altLabel: useAltLabel(option) }"
            @click="radioClick(option)"
            :detail="option.isCustomPizza"
        >
            <div v-html="labelDisplay(option)" class="ion-text-capitalize interstate-bold ion-text-wrap"></div>
            <ion-radio :aria-labelledby="labelDisplay(option)" slot="start" :value="option" :data-cy="'radio-' + createSlug(option[keyName])" :class="{ left, right }" />
        </ion-item>
    </ion-radio-group>
</template>

<script lang="ts">
import { defineComponent, computed, nextTick } from 'vue';
import { IonRadioGroup, IonRadio, IonItem } from '@ionic/vue';
import { createSlug } from '@/services/stringService';
export default defineComponent({
    props: {
        modelValue: {
            type: undefined,
        },
        options: { type: Array, required: true },
        keyName: { type: String, required: true },
        dense: Boolean,
        left: Boolean,
        right: Boolean,
        selectedKey: String,
        defaultFirst: Boolean,
        sortKey: String,
        forceReselect: Boolean,
    },
    components: { IonRadioGroup, IonRadio, IonItem },
    setup(props, { emit }) {
        const localModelValue = computed({
            get: () => props.modelValue,
            set: (newValue) => emit('update:modelValue', newValue),
        });
        const useAltLabel = (option) => localModelValue.value === option && !!props.selectedKey;
        const labelDisplay = (option) => {
            //@ts-ignore
            return option[useAltLabel(option) ? props.selectedKey : props.keyName];
        };
        //@ts-ignore
        const sorted = computed(() => (props.sortKey ? [...props.options].sort((a, b) => a[props.sortKey] - b[props.sortKey]) : props.options));

        const radioClick = (option) => {
            localModelValue.value = option;
            if (option.isCustomPizza) emit('update', option);
        };
        nextTick(() => {
            if (!localModelValue.value && props.defaultFirst) {
                radioClick(props.options[0]);
            } else if (props.forceReselect && localModelValue.value) {
                // This is necessary when editing party size wings to allow everything to finish processing
                setTimeout(() => {
                    //@ts-ignore
                    radioClick(props.options.find((o) => o['id'] == localModelValue.value['id']));
                }, 200);
            }
        });

        return { localModelValue, radioClick, labelDisplay, useAltLabel, createSlug, sorted };
    },
});
</script>

<style scoped>
.dense.item-radio-checked.altLabel {
    max-height: unset !important;
    overflow: initial;
    margin-top: 11px;
    z-index: 0;
}
.dense.item-radio-checked.altLabel > ion-radio {
    align-self: start;
    top: 6px;
}

.dense > * {
    margin: 0;
}
.dense > ion-radio {
    margin-right: 16px;
}
ion-item {
    --inner-padding-end: 0;
}
@media screen and (max-width: 960px) {
    .dense > ion-radio {
        margin-right: 8px !important;
    }
    .dense {
        font-size: 1em;
    }
}
</style>
